import React, { PropTypes } from 'react';

class Remarks extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {

    const {
      value,
      onChange,
      label,
      inputClassName,
      cols,
      rows,
      className,
    } = this.props;

    return (
      <div className={'row ' + className}>
        <div className='col-xs-3'>
          <span className='remarks-label'>{label}</span>
        </div>
        <div className='col-xs-9'>
          <textarea
            className={inputClassName}
            cols={cols}
            rows={rows}
            value={value}
            onChange={onChange}
           />
        </div>
      </div>

    );
  }
}

export default Remarks;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Remarks.js